<template>
  <parent-tabs :tabs="filterTabs()" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LotListParent',
  methods: {
    filterTabs () {
      return this.pageTabs.reduce((accu, i) => {
        if (i.can) accu.push(i)
        return accu
      }, [])
    }
  },
  computed: {
    ...mapGetters({
      can: 'can'
    }),
    pageTabs () {
      return [
        { id: 1, title: 'List', route: '/lot-list', can: this.can('api.view_lot') },
        { id: 2, title: 'Shipped', route: '/lot-list/shipped', can: this.can('api.view_lot') },
        { id: 3, title: 'Create', route: '/create-lot', can: this.can('api.add_lot') },
        { id: 4, title: 'Position report', route: '/position-report/', can: this.can('api.view_lot_report') }
      ]
    }
  }
}
</script>
